import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getSessionStatusBadgeClasses(status: string | null | undefined): string {
  switch (status) {
    case "Completed":
      return "bg-green-500 text-white hover:bg-green-600 border-transparent";
    case "Approved":
      return "bg-blue-500 text-white hover:bg-blue-600 border-transparent";
    case "Cancelled":
      return "bg-destructive text-destructive-foreground hover:bg-destructive/80 border-transparent";
    case "Scheduled":
    default:
      return "";
  }
}
